import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Link } from '@atlassian/amkt-common';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ExternalLink = props => {
  const ariaLabel = props['aria-label'] || typeof props.children === 'string' && props.children;
  return /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({
    target: "_blank",
    rel: "noopener noreferrer"
  }, props), {}, {
    "aria-label": ariaLabel ? "".concat(ariaLabel, " (open in new window)") : undefined,
    children: props.children
  }));
};
export default ExternalLink;